<template>
    <div class="w-100">
        <div class="map-item-filter">
            <div
                class="col-sm-12 nopads vehicle-list"
            >
                <span
                    class="vehicle-list-title"
                    @click.stop="toggleList"
                >
                    {{ $t('vehicle_list.title') }} ({{ logEntries ? logEntries.length : 0 }})
                </span>
                <div
                    class="vehicle-list-caret"
                    :class="{ caret_open: listOpen }"
                    @click.stop="toggleList"
                >
                    <font-awesome-icon icon="caret-down" />
                </div>
                <!-- Accordion content -->
                <div
                    class="col-sm-12 nopads map-accordion-content"
                    :class="{'map-accordion-open': listOpen}"
                >
                    <div
                        :class="{ 'm-2': listOpen }"
                        class="nopads"
                    >
                        <div
                            v-if="!isMapViewer"
                            class="form-check form-switch text-light ml-1 mr-1 mb-2"
                        >
                            <input
                                id="showLicensePlate"
                                v-model="showLicensePlate"
                                class="form-check-input"
                                type="checkbox"
                            >
                            <label
                                class="form-check-label"
                                for="showLicensePlate"
                            >
                                {{ $t('map.show_license_plate') }}
                            </label>
                        </div>
                        <div
                            v-if="!isMapViewer"
                            class="form-check form-switch text-light ml-1 mr-1 mb-2"
                        >
                            <input
                                id="showVehicleOwner"
                                v-model="showVehicleOwner"
                                class="form-check-input"
                                type="checkbox"
                            >
                            <label
                                class="form-check-label"
                                for="showVehicleOwner"
                            >
                                {{ $t('map.show_vehicle_owner') }}
                            </label>
                        </div>

                        <hr
                            class="nopads px-2 mb-2"
                            style="border-color: #6e914c"
                        >
                        <div class="col-12 nopads text-center">
                            <div class="badge-filters__wrapper">
                                <div
                                    v-if="selectedContractIds && selectedContractIds.length > 0"
                                    id="badge-filters"
                                    class="badge-filters"
                                >
                                    <span
                                        v-for="item in timeFilterOptions"
                                        :key="item.value"
                                        class="d-inline-block"
                                        tabindex="0"
                                        :title="isDisabled(item) ? $t('vehicle_list.select_contract_filter') : ''"
                                    >
                                        <span
                                            class="badge badge-item"
                                            :class="[
                                                isDisabled(item)
                                                    ? 'bg-secondary disabled-badge'
                                                    : historyMode === item.value
                                                        ? 'bg-primary'
                                                        : 'bg-light text-dark',
                                            ]"
                                            :style="isDisabled(item) ? 'pointer-events: none; opacity: 0.65;' : ''"
                                            role="button"
                                            @click="!isDisabled(item) && (historyMode = item.value)"
                                        >
                                            {{ item.text }}
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <span
                            v-if="selectedContractIds && selectedContractIds.length > 0 && historyMode === historyModes.SLIDER"
                            class="vehicle-list-no-results nopads"
                        >{{ historyValue + ' ' + 'h' }}</span>
                        <!-- History Slider -->
                        <input
                            v-if="selectedContractIds && selectedContractIds.length > 0 && historyMode === historyModes.SLIDER"
                            id="range"
                            v-model="historyValue"
                            type="range"
                            class="form-range mb-2"
                            :min="minHours"
                            :max="maxHours"
                            @change="updateHistoryValues"
                        >
                        <!-- Date Inputs for fromDate and toDate -->
                        <div
                            v-if="historyMode === historyModes.USER_INPUT"
                            class="row nopads calendar-container pb-2"
                        >
                            <div class="col-12 nopads pr-1">
                                <span class="search-title white-text">{{ $t('trip_list.road_sec_from') }}</span>
                                <div
                                    class="nopads"
                                >
                                    <date-time-picker
                                        v-model:date="fromDate"
                                        class="routa-input"
                                        format="dd.MM.yyyy HH:mm"
                                        :enable-time-picker="true"
                                        :set-time-button-visible="true"
                                        :placeholder="$t('observations_videos.search_input_format')"
                                    />
                                </div>
                            </div>
                            <div class="col-12 nopads pr-1">
                                <span class="search-title white-text">{{ $t('trip_list.road_sec_to') }}</span>
                                <div
                                    class="nopads"
                                >
                                    <date-time-picker
                                        v-model:date="toDate"
                                        class="routa-input"
                                        format="dd.MM.yyyy HH:mm"
                                        :enable-time-picker="true"
                                        :set-time-button-visible="true"
                                        :placeholder="$t('observations_videos.search_input_format')"
                                    />
                                </div>
                            </div>
                            <div class="button-container pt-2">
                                <button
                                    size="md"
                                    class="btn btn-sm btn-success"
                                    :disabled="!fromDate || !toDate"
                                    @click.stop="updateHistoryValues"
                                >
                                    <span class="map-button-text">{{ $t('ins_report.search') }}</span>
                                </button>
                            </div>
                        </div>
                        <hr
                            v-if="selectedContractIds && selectedContractIds.length > 0"
                            class="nopads px-2 mb-2 "
                            style="border-color: #6e914c"
                        >
                        <div
                            v-if="selectedContractIds && selectedContractIds.length > 0"
                            class="col-12 nopads text-center"
                        >
                            <div class="badge-filters__wrapper">
                                <div class="badge-filters">
                                    <span
                                        v-for="item in roadOwnerOptions"
                                        :key="item.value"
                                        class="badge badge-item"
                                        :class="roadOwnership === item.value ? 'bg-primary text-light' : 'bg-light text-dark'"
                                        style="cursor: pointer;"
                                        @click="roadOwnership = item.value"
                                    >
                                        {{ item.text }}
                                    </span>
                                </div>
                            </div>
                            <hr
                                class="nopads px-2 mb-2"
                                style="border-color: #6e914c"
                            >
                        </div>

                        <!-- vehicle list -->
                        <div
                            v-if="logEntries && logEntries.length > 0 && listOpen"
                            class="col-sm-12 nopads vehicle-list-container vehicle-list-smaller-max-height"
                        >
                            <div
                                v-for="item of logEntries"
                                :key="item.id"
                                class="vehicle-list-item"
                                @click.stop="showVehicleInfo(item.vehicle.id)"
                            >
                                <div class="col-12">
                                    <div class="vehicle-list-icon">
                                        <font-awesome-icon
                                            :icon="getIcon(item.vehicle.vehicle_type)"
                                            :class="{ fresh: isActive(item) }"
                                        />
                                    </div>
                                    <div
                                        v-if="!isMapViewer"
                                        class="vehicle-list-header"
                                    >
                                        {{ item.vehicle.license_plate }}
                                    </div>
                                </div>
                                <div v-if="!isMapViewer">
                                    {{ item.vehicle.make }} {{ item.vehicle.vehicle_model }}
                                </div>
                                <div v-else>
                                    {{ getVehicleTypeName(item.vehicle.vehicle_type) }}
                                </div>
                                <div
                                    v-if="isObserver"
                                    class="vehicle-list-task"
                                >
                                    <strong>{{ item.vehicle.company.name }}</strong> {{ item.driver ? (' - ' + item.driver ) : '' }}
                                </div>
                                <div
                                    v-if="item.routes && item.routes.length > 0"
                                    class="col-12 nopads"
                                >
                                    <div
                                        v-if="item.routes[0].contract"
                                        class="col-6 vehicle-list-task word-break"
                                    >
                                        {{ item.routes[0].contract }}
                                    </div>
                                    <div
                                        v-if="item.routes[0].order"
                                        class="col-6 vehicle-list-task"
                                    >
                                        <div
                                            class="task-type-circle"
                                            :style="{ backgroundColor: getTraceColor(item.routes[0].mode, item.routes[0].trace_color) }"
                                        />
                                        {{ item.routes[0].order }}
                                    </div>
                                </div>
                                <div
                                    v-else
                                    class="vehicle-list-task"
                                >
                                    {{ $t('vehicle_list.no_contract') }}
                                </div>
                            </div>
                        </div>
                        <span
                            v-else-if="!logEntries || logEntries.length < 1"
                            class="vehicle-list-no-results"
                        >{{ $t('vehicle_list.no_results') }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div
            v-if="loading"
            id="loader"
            class="spinner"
        />
    </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {logModes, vehicleHelper} from '../mixins/VehicleMixin'
import {timeUtils} from '../mixins/TimeUtils'
import {mapHelper} from '../mixins/MapMixin'
import {mapActions, mapState} from "vuex";
import DateTimePicker from "@/components/common/DateTimePicker";

export const historyModes = {
    NO_HISTORY: null,
    SLIDER: 1,
    USER_INPUT: 2,
    NO_LIMIT: 3,
}

export default {
    name: 'MapVehicles',
    components: { DateTimePicker },
    mixins: [restApi, vehicleHelper, timeUtils, mapHelper],
    props: {
        map: {
            type: Object,
            default: null
        },
        isObserver: Boolean,
        isMapViewer: Boolean,
        showHistory: {
            type: Boolean,
            default: false
        },
        hours: {
            type: Number,
            default: 6
        },
        roadOwner: {
            type: Number,
            default: null
        }
    },
    data: function () {
        return {
            minHours: 1,
            maxHours: 24,
            historyValue: 2,
            fromDate: null,
            toDate: null,
            loading: false,
            listOpen: false,
            infoVehicle: -1,
            logEntries: [],
            polyLines: [],
            historyModes: historyModes,
            logModes: logModes,
            timer: null,
            destroyed: false,
            fetching: false,
            selectedTaskTypeValue: null,
            historyMode: null,
            showHistoryValue: false,
            showLicensePlate: false,
            showVehicleOwner: false,
            roadOwnership: null,
            contractChanged: false
        }
    },
    computed: {
        ...mapState({
            selectedContractIds: (state) => state.contracts.selectedContractIds,
            selectedContract: (state) => state.contracts.selectedContract,
            selectedTaskType: (state) => state.contracts.selectedTaskType,
            selectedTaskTypes: (state) => state.contracts.selectedTaskTypes,
            selectedOrder: (state) => state.contracts.selectedOrder,
            isLoadingContracts: (state) => state.contracts.isLoading,
            selectedHistoryValue: (state)=> state.contracts.historyHours,
            selectedHistoryMode: (state) => state.contracts.historyMode
        }),
        tableFields() {
            if (this.isObserver) {
                return [
                    {
                        key: "vehicle",
                        label: this.$t('vehicle_position.vehicle'),
                    },
                    {
                        key: "time",
                        label: this.$t('vehicle_position.time'),
                    },
                    {
                        key: "mode",
                        label: this.$t('vehicle_position.mode'),
                    },
                    {
                        key: "company",
                        label: this.$t('vehicle_position.company'),
                    },
                    {
                        key: "driver",
                        label: this.$t('trip_list.driver'),
                    },
                    {
                        key: "customer",
                        label: this.$t('vehicle_position.customer'),
                    },
                    {
                        key: "contract",
                        label: this.$t('vehicle_position.contract'),
                    },
                    {
                        key: "order",
                        label: this.$t('vehicle_position.order'),
                    }
                ]
            }
            return [
                {
                    key: "vehicle",
                    label: this.$t('vehicle_position.vehicle')
                },
                {
                    key: "time",
                    label: this.$t('vehicle_position.time'),
                },
                {
                    key: "mode",
                    label: this.$t('vehicle_position.mode'),
                },
                {
                    key: "contract",
                    label: this.$t('vehicle_position.contract'),
                },
                {
                    key: "order",
                    label: this.$t('vehicle_position.order'),
                }
            ]
        },
        timeFilterOptions() {
            return [
                {text: this.$t('common.no_history'), value: historyModes.NO_HISTORY},
                {text: this.$t('common.hour_range'), value: historyModes.SLIDER},
                {text: this.$t('common.time_range'), value: historyModes.USER_INPUT},
                {text: this.$t('common.no_limit'), value: historyModes.NO_LIMIT}
            ]
        },
        roadOwnerOptions() {
            return [
                { text: this.$t('common.all'), value: null },
                { text: this.$t('common.municipality'), value: 2 },
                { text: this.$t('common.government'), value: 1 },
                { text: this.$t('common.private'), value: 3 }
                /*{ text: this.$t('common.unknown'), value: 99 }*/
            ]
        },
        isDisabled() {
            return (item) => {
                return (
                    (!this.selectedContractIds || this.selectedContractIds.length < 1) &&
                    (item.value === historyModes.NO_LIMIT || item.value === historyModes.USER_INPUT)
                )
            }
        }
    },
    watch: {
        showLicensePlate() {
            this.updateVehicleLabels()
        },
        showVehicleOwner() {
            this.updateVehicleLabels()
        },
        selectedContractIds() {
            this.contractChanged = true
            this.hideVehicles()
            if (this.selectedContractIds.length < 1 && (this.historyMode === historyModes.NO_LIMIT || this.historyMode === historyModes.USER_INPUT)) {
                this.historyMode = historyModes.NO_HISTORY
            }
            this.updateHistoryValues()
            this.fetchVehicles()
        },
        selectedTaskType() {
            this.hideVehicles()
            this.updateHistoryValues()
            this.fetchVehicles()
        },
        selectedTaskTypes() {
            this.hideVehicles()
            this.updateHistoryValues()
            this.fetchVehicles()
        },
        selectedOrder() {
            this.hideVehicles()
            this.updateHistoryValues()
            this.fetchVehicles()
        },
        roadOwnership() {
            this.updateHistoryValues()
        },
        historyMode() {
            if (this.historyMode !== historyModes.USER_INPUT) {
                this.updateHistoryValues()
            }
            // Save to map prefs, if mode is SLIDER
            if (this.historyMode === historyModes.SLIDER) {
                this.setHistoryMode(this.historyMode)
                this.setHistoryHours(this.historyValue)
            } else {
                this.setHistoryMode(historyModes.NO_HISTORY)
            }
        },
        fromDate() {
            this.setFromDate(this.fromDate)
        },
        toDate() {
            this.setToDate(this.toDate)
        }
    },
    mounted: function () {
        this.showHistoryValue = this.showHistory
        this.historyValue = this.hours;
        this.roadOwnership = this.roadOwner;
        this.historyMode = this.selectedHistoryMode
        this.historyValue = this.selectedHistoryValue
        // Poor solution that waits for props changes before updating storages
        setTimeout(() => {
            if (!this.contractChanged) {
                this.contractChanged = true
                this.boxChanged = true
                this.updateHistoryValues()
                this.fetchVehicles()
            }
        }, 1500);
    },
    beforeUnmount: function () {
        this.destroyed = true
        if (this.timer) {
            clearTimeout(this.timer)
        }
        this.hideVehicles()
    },
    methods: {
        ...mapActions('contracts', ['selectTaskType', 'setFromDate', 'setToDate', 'setHistoryMode', 'setHistoryHours']),

        fetchVehicles: function () {
            if (!this.fetching && this.contractChanged) {
                let params = {}
                this.fetching = true
                if (this.timer) {
                    clearTimeout(this.timer)
                } else {
                    this.loading = true
                }
                if(this.selectedContractIds) {
                    params.contract_id = this.selectedContractIds
                }
                if(this.selectedOrder) {
                    params.order = this.selectedOrder
                } else if (this.selectedTaskType) {
                    params.taskType = this.selectedTaskType
                } else if (this.selectedTaskTypes && this.selectedTaskTypes.length > 0) {
                    params.taskTypes = this.selectedTaskTypes.map(taskType => taskType.value);
                }
                this.restFetchParams(this.lastPositionUrl, params, this.handleResponse)
            }
        },

        handleResponse: function (response) {
            this.loading = false
            this.fetching = false
            if (response) {
                this.logEntries = response.data
                this.showVehicles()
                if (this.infoVehicle > 0) {
                    this.showVehicleInfo(this.infoVehicle)
                }
            }
            if (!this.destroyed) {
                this.timer = setTimeout(this.fetchVehicles, 30000)
            }
        },

        updateHistoryValues() {
            let from, to
            if(this.historyMode === historyModes.SLIDER) {
                let startTime = (new Date()).getTime() - (this.historyValue * 60 * 60 * 1000)
                from = (new Date(startTime)).toISOString()
            } else if (this.historyMode === historyModes.USER_INPUT) {
                from = this.fromDate
                to = this.toDate
            }
            this.$emit('historyChange', this.historyMode, from, to, this.roadOwnership)
        },

        getVehicleOwnerName(vehicle) {
            if (vehicle.owner) {
                return vehicle.owner
            }
            if (vehicle.company && vehicle.company.name) {
                return vehicle.company.name
            }
            return null
        },

        getVehicleOwnerLabel(vehicle) {
            const ownerName = this.getVehicleOwnerName(vehicle)
            if (!ownerName) {
                return null
            }
            const maxLength = 10
            return ownerName.length > maxLength ? ownerName.slice(0, maxLength) + '...' : ownerName
        },

        getVehicleLabelText(vehicle) {
            const licensePlate = vehicle.license_plate
            const ownerName = this.getVehicleOwnerLabel(vehicle)
            if (this.showLicensePlate && licensePlate) {
                if (this.showVehicleOwner && ownerName) {
                    return `${licensePlate} - ${ownerName}`
                }
                return licensePlate
            }
            if (this.showVehicleOwner && ownerName) {
                return ownerName
            }
            return null
        },

        updateVehicleLabel(item, latest) {
            if (!this.map || !item || !latest || !latest.points || !latest.points[0]) {
                return
            }
            const label = this.getVehicleLabelText(item.vehicle)
            if (label) {
                this.map.addVehicleLabel(item.vehicle.id, label, latest.points[0].y, latest.points[0].x)
            } else {
                this.map.hideVehicleLabelIfExists(item.vehicle.id)
            }
        },

        updateVehicleLabels() {
            if (!this.map) {
                return
            }
            this.logEntries.forEach(item => {
                if (item.routes && item.routes.length > 0) {
                    this.updateVehicleLabel(item, item.routes[0])
                }
            })
        },


        hideVehicles: function () {
            if (this.timer) {
                clearTimeout(this.timer)
            }
            if (this.map) {
                this.logEntries.forEach(item => {
                    this.map.removeMapMarker(item.vehicle.id, this.VEHICLE);
                    this.map.hideVehicleLabelIfExists(item.vehicle.id)
                })
                this.polyLines.forEach(line => {
                    this.map.removePolyline(line, this.TRACE)
                })
                this.hideVehicleInfo()
                this.hideTraceInfo()
            }
        },

        getFreshLimit: function () {
            return Date.now() - 1000 * 60 * 5 // 5 minute old vehicle entries shown as active, older as passive
        },

        showVehicles: function () {
            var freshLimit = this.getFreshLimit()
            // One 'logEntry' is an object containing information about the vehicle and it's routes
            this.logEntries.forEach(item => {
                if (item.routes && item.routes.length > 0) {
                    // Draw marker for latest point
                    var vehicle = item.vehicle;
                    var latest = item.routes[0]
                    latest.endTime = this.setTime(latest.endTime)
                    var fresh = Date.parse(latest.endTime) > freshLimit
                    var marker = this.getVehicleMarker(vehicle.vehicle_type, fresh, this.map.getMarkerStore())
                    this.map.showMapMarker(vehicle.id, this.VEHICLE, latest.points[0].y, latest.points[0].x, marker)
                    this.updateVehicleLabel(item, latest)
                    item.routes.forEach(log => {
                        if (log.points.length > 1) {
                            this.drawVehicleTrace(log.id, log.points, log.mode, log.trace_color)
                            this.polyLines.push(log.id)
                        }
                    })
                }
            })
        },

        drawVehicleTrace: function (id, coords, mode, color) {
            var dash = false
            switch (mode) {
            case logModes.WORK:
                if (!color) {
                    color = '#00FF21'
                }
                break
            case logModes.PROGRAM:
                color = '#2121FF'
                break
            case logModes.RESETTLE:
                color = '#89898a'
                dash = true
                break
            }
            this.map.drawPolyLine(id, this.TRACE, coords, color, dash)
        },

        onMarkerTap: function (data) {
            if (data.id === this.infoVehicle) {
                this.hideVehicleInfo()
            } else {
                this.showVehicleInfo(data.id)
            }
        },

        onPolylineTap: function (data) {
            if (data.type && data.type === this.TRACE) {
                if (data.id === this.infoTrace) {
                    this.hideTraceInfo()
                } else {
                    this.showTraceInfo(data.id)
                }
            }
        },

        showTraceInfo: function (id) {
            this.hideVehicleInfo()
            var trace = null
            let vehicle
            let driver
            let sensorValues = []
            for (let i = 0; i < this.logEntries.length; i++) {
                let item = this.logEntries[i]
                trace = item.routes.find(route => route.id === Number(id))
                if (trace) {
                    vehicle = item.vehicle
                    driver = item.driver
                    sensorValues = item.sensorValues || []
                    break
                }
            }
            if (!trace) {
                return
            }
            this.infoTrace = id
            this.map.showMapInfo(this.tableFields, this.getInfoContent(vehicle, trace, driver), false, sensorValues)
        },

        hideTraceInfo: function () {
            if (this.infoTrace) {
                this.map.hideMapInfo()
                this.infoTrace = -1
            }
        },

        onMapInfoClosed: function () {
            this.clearVehicleSelection()
            this.infoVehicle = -1
            this.infoTrace = -1
        },

        showVehicleInfo: function (id) {
            this.hideTraceInfo()
            var item = this.logEntries.find(item => item.vehicle.id === id)
            if (!item || !item.routes) {
                return
            }
            this.infoVehicle = id
            this.map.showMapInfo(this.tableFields, this.getInfoContent(item.vehicle, item.routes[0], item.driver), false, item.sensorValues || [])
            this.map.zoomToPosition(item.routes[0].points[0].y, item.routes[0].points[0].x)
            this.updateVehicleSelection(id)
        },

        hideVehicleInfo: function () {
            if (this.infoVehicle > 0) {
                this.clearVehicleSelection()
                this.map.hideMapInfo()
                this.infoVehicle = -1
            }
        },

        getVehicleStr: function (vehicle) {
            var result = ''
            if (vehicle.make) {
                result += vehicle.make + ' '
            }
            if (vehicle.vehicle_model) {
                result += vehicle.vehicle_model + ' '
            }
            if (vehicle.license_plate) {
                result += vehicle.license_plate
            }
            return result
        },

        getInfoContent: function (vehicle, route, driver) {
            if (this.isObserver) {
                return [{
                    vehicle: this.getVehicleStr(vehicle),
                    time: route.startTime && route.endTime ? this.toLocalTime(route.startTime) + ' - ' + this.toLocalTime(route.endTime) : '-',
                    mode: route.mode ? this.getTripModeString(route.mode) : '-',
                    company: vehicle.company.name ? vehicle.company.name : '-',
                    driver: driver ? driver : '-',
                    customer: route.customer ? route.customer : '-',
                    contract: route.contract ? route.contract : '-',
                    order: route.order ? route.order : '-'
                }]
            }
            // Show less for map viewer
            return [{
                vehicle: this.getVehicleTypeName(vehicle.vehicle_type),
                time: route.startTime && route.endTime ? this.$d(new Date(this.setTime(route.startTime)), 'short') + ' - ' +
                    this.$d(new Date(this.setTime(route.endTime)), 'short') : '-',
                mode: route.mode ? this.getTripModeString(route.mode) : '-',
                contract: route.contract ? route.contract : '-',
                order: route.order ? route.order : '-'
            }]

        },

        getLocationStr: function (entry) {
            var result = ''
            if (entry.road_num) {
                result += entry.road_num + ' '
            }
            if (entry.sec_num) {
                result += '/ ' + entry.sec_num + ' '
            }
            if (entry.road_name) {
                result += entry.road_name + ' '
            }
            if (entry.city) {
                result += entry.city.name
            }
            return result
        },

        isActive: function (item) {
            if (item && item.routes && item.routes.length > 0) {
                return Date.parse(item.routes[0].endTime) > this.getFreshLimit()
            }
            return false
        },

        toggleList: function () {
            this.listOpen = !this.listOpen
        },

        updateVehicleSelection: function (vehicleId) {
            this.clearVehicleSelection()
            const marker = this.map.markersById?.[this.VEHICLE]?.[vehicleId]
            if (marker?.getElement) {
                const el = marker.getElement()
                if (el) {
                    const icon = el.querySelector('.vehicle-marker')
                    if (icon) icon.classList.add('vehicle-selected')
                }
            }
        },

        clearVehicleSelection: function () {
            if (!this.map || !this.map.markersById?.[this.VEHICLE]) return
            const markers = this.map.markersById[this.VEHICLE]
            for (const key in markers) {
                const marker = markers[key]
                if (marker?.getElement) {
                    const el = marker.getElement()
                    if (el) {
                        const icon = el.querySelector('.vehicle-selected')
                        if (icon) icon.classList.remove('vehicle-selected')
                    }
                }
            }
        },

        getTraceColor: function (mode, color) {
            if (mode === logModes.WORK) {
                return color
            }
            return '#bcbcbc'
        },
    }
}
</script>
<style>
.badge-item {
    min-width: 90px;
    max-width: 110px;
    padding: .5em 1em;
    text-align: center;
    display: inline-block;
}
.disabled-badge {
    pointer-events: none;
    opacity: 0.6;
    cursor: not-allowed;
}

.calendar-container {
    Transition: margin 0.3s ease;
}

.calendar-open {
    margin-bottom: 15em;
    z-index: 999;
}
</style>
